import styled from '@emotion/styled';

export const LoadingSection = styled.div({
  width: 40,
});
